<template>
  <v-dialog
    v-model="userEditDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('users.editUser') }}</b>
      </v-card-title>
      <v-card-text>
        <v-flex mt-5>
          <v-text-field
            v-model.trim="form.name"
            :label="$t('globals.name')"
            :error-messages="NameError"
            maxlength="50"
            @input="$v.form.name.$touch()"
            @blur="$v.form.name.$touch()"
          />
          <v-text-field
            v-model.trim="form.email"
            maxlength="50"
            :error-messages="EmailError"
            :label="$t('globals.email')"
            @input="$v.form.email.$touch()"
            @blur="$v.form.email.$touch()"
          />
          <v-text-field
            v-model.trim="form.phone"
            :error-messages="PhoneError"
            prefix="+"
            :label="$t('users.phone')"
            @input="$v.form.phone.$touch()"
            @blur="$v.form.phone.$touch()"
          />
          <v-text-field
            v-model.trim="form.telegram"
            maxlength="50"
            prefix="@"
            :label="$t('users.telegramUser')"
          />
          <v-text-field
            v-model.trim="form.reference_id"
            :error-messages="ReferenceIDError"
            maxlength="50"
            :label="$t('users.refId')"
          />
        </v-flex>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="userEditDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="save()"
        >
          {{ $t('globals.saveButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import USER_UPDATE_MUTATION from "@/graphql/mutations/WhiteLabelUpdateUser.gql";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";

import { parsePhoneNumber } from 'awesome-phonenumber'

const check_phone = phone => {
  if (phone == null || phone == "") return true;
  const pn = parsePhoneNumber('+'+phone);
  return pn.valid;
};

export default {
  name: "UserEditDialog",
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        email: null,
        phone: null,
        telegram: null,
        reference_id: null
      }
    };
  },
  computed: {
    userEditDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeUserEditDialog', false);
      }
    },
    rules() {
      var form = {
        name: {
          required,
          minLength: minLength(2)
        },
        email: {
            required,
            email,
            maxLength: maxLength(50),
        },
        phone: {
          check_phone,
        },
        reference_id: {
          minLength: minLength(2)
        }
      };
      return form;
    },
    NameError() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.name.minLength &&
        errors.push(this.$t("globals.minError", {char: this.$v.form.name.$params.minLength.min}));
      return errors;
    },
    EmailError () {
      const errors = []
      if (!this.$v.form.email.$dirty) return errors
      !this.$v.form.email.required &&
        errors.push(this.$t('register.reqEmail'))
      !this.$v.form.email.email &&
        errors.push(this.$t('register.validEmail')) 
      !this.$v.form.email.maxLength &&
        errors.push(this.$t('register.mustEmail'))
      return errors
    },
    PhoneError() {
      const errors = [];
      if (!this.$v.form.phone.$dirty) return errors;
      !this.$v.form.phone.check_phone &&
        errors.push(this.$t("profile.phoneBadFormat"));
      return errors;
    },
    ReferenceIDError() {
      const errors = [];
      if (!this.$v.form.reference_id.$dirty) return errors;
      !this.$v.form.reference_id.minLength &&
        errors.push(this.$t("globals.minError", {char: this.$v.form.reference_id.$params.minLength.min}));
      return errors;
    },
  },
  validations() {
    return {
      form: this.rules
    };
  },
  mounted() {
    this.form = {
      user_uuid: this.user.uuid,
      name: this.user.name,
      email: this.user.email,
      phone: this.user.phone,
      telegram: this.user.telegram,
      reference_id: this.user.reference_id
    };
  },
  methods: {
     save() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const params = { ...this.form}
     
      if (params.phone != null && params.phone != "") {
        params.phone = '+' + params.phone
      }
      this.$apollo
        .mutate({
          mutation: USER_UPDATE_MUTATION,
          variables: params
        })
        .then(data => {
          this.loading = false;
          this.$emit('closeUserEditDialog', true);
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss" >
</style>
